/**
 * This function will sort the current user as first and alphabetically the other users
 *
 * Example of sorted names order with current user "Jack Daniels":
 * Jack Daniels
 * Avi
 * Former member
 * simha-rotman@gmail.com
 * Tomer
 * Zach
 */
import { useMemo } from 'react';
import { useUser } from '@adsk/alloy-provider';
import { useOxygen } from '../../../providers/OxygenProvider';
import { Assignee } from '../../../sdk';
import { sortAssigneesWithCurrentUserFirst } from '../../../helpers/assigned-to-helpers';

export const useSortAssignees = (assignees?: Assignee[]) => {
  const { user } = useUser();
  const oxygen = useOxygen();

  const sortedAssignees = useMemo(
    () => sortAssigneesWithCurrentUserFirst(assignees || [], oxygen, user),
    [assignees, oxygen, user],
  );

  return sortedAssignees;
};
